import React from 'react';
import CustomCard from '../../../../shared/CustomCard';
import {
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  UserIcon,
  UsersIcon,
  DocumentTextIcon,
  CalendarIcon,
  ChartBarIcon
} from '@heroicons/react/20/solid';
import { Box, Typography } from '@mui/material';

function Reports() {
  const reports = [
    {
      title: 'Eligibility Report',
      icon: ClipboardDocumentCheckIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Not Eligible Report',
      icon: ClipboardDocumentListIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Payer wise Not Eligible',
      icon: UserIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Payer wise Eligible',
      icon: UserIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Policy wise Eligibility',
      icon: DocumentTextIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Monthly Report',
      icon: CalendarIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    },
    {
      title: 'Date Wise Eligibility',
      icon: ChartBarIcon,
      progessMessage: 'Eligibility Reports are currently being developed and will be available soon.'
    }
  ];

  return (
    <Box sx={{ p: 1 }}>
      {/* <Typography
        variant='h5'
        gutterBottom
        sx={{
          fontWeight: 600,
          mb: 3,
          color: '#373d45',
          fontSize: '1.5rem'
        }}
      >
        Eligibility Reports
      </Typography> */}

      <Box className=' grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
        {reports.map((report, index) => (
          <CustomCard
            key={index}
            title={report?.title}
            icon={report?.icon}
            path={report?.path}
            color='#0070C2'
            progessMessage={report?.progessMessage}
          />
        ))}
      </Box>
    </Box>
  );
}

export default Reports;
